<script>
import LoginFormItemInput from './LoginFormItemInput.vue'

import BaseButton from '@/components/lavender/Button/BaseButton.vue'

export default {
  name: 'LoginForgotPasswordForm',
  components: {
    BaseButton,
    LoginFormItemInput,
  },
  props: {
    submitting: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      email: '',
    }
  },
  methods: {
    handleSubmitEmail() {
      this.$emit('submit', this.email)
    },
  },
}
</script>

<template>
  <div class="tamara-login-forgot-password-form px-5">
    <div class="tamara-login-forgot-password-form__header">
      <div
        class="tamara-login-forgot-password-form__title tamara-heading-large"
      >
        {{ $t('forgot_password_title') }}
      </div>
      <div
        class="tamara-login-forgot-password-form__description tamara-body-medium"
      >
        {{ $t('forgot_password_text') }}
      </div>
    </div>
    <div class="tamara-login-forgot-password-form__body">
      <LoginFormItemInput
        id="email"
        v-model="email"
        name="Email"
        error-message-is-static
        :label="$t('login_email_label')"
        :placeholder="$t('email_placeholder')"
        :error-message="$t(errorMessage)"
        :disabled="submitting"
      />
    </div>
    <div class="tamara-login-forgot-password-form__footer">
      <BaseButton
        class="w-full"
        type="primary"
        :loading="submitting"
        :disabled="!email"
        @click.native.prevent="handleSubmitEmail"
      >
        {{ $t('forgot_password_button') }}
      </BaseButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';
@import '@/styles/_breakpoints.scss';

.tamara-login-forgot-password-form {
  --tamara-login-forgot-password-form-body-gap: 32px;

  display: flex;
  flex-direction: column;
  gap: var(--tamara-login-forgot-password-form-body-gap);
  width: 100%;
  max-width: 480px;
  background-color: var(--tamara-background-color-primary);
  border-radius: var(--tamara-border-radius-lg);

  &__header {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__title {
    color: var(--tamara-color-functional-grey-dark-2);
  }

  &__description {
    color: var(--tamara-color-functional-grey-dark-1);
  }

  @include breakpoints(mobile) {
    padding: 40px;
  }
}
</style>
